export const USER_VERIFICATION_REQUEST = 'USER_VERIFICATION_REQUEST'
export const USER_VERIFICATION_SUCCESS = 'USER_VERIFICATION_SUCCESS'
export const USER_VERIFICATION_FAILURE = 'USER_VERIFICATION_FAILURE'
